/**
 * Service for area enable/disable operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';


export class AreaEnableDisableService {
  /**
   * Enable an area (PATCH /v1/areas/{id}/enable)
   * Backend returns 204 No Content on success
   */
  async enable(areaId: number): Promise<ApiResponse<null>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.ENABLE_AREA(areaId);

    return await apiClient.patch<null>(endpoint, {});
  }

  /**
   * Disable an area (PATCH /v1/areas/{id}/disable)
   * Backend returns 204 No Content on success
   */
  async disable(areaId: number): Promise<ApiResponse<null>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.DISABLE_AREA(areaId);

    return await apiClient.patch<null>(endpoint, {});
  }
}

export const areaEnableDisable = new AreaEnableDisableService();
